import { AxiosResponse, AxiosError } from 'axios';

/**
 * returns formatted thrown error
 * @param {object} err - error object
 */
export const getErrorMessage = (err: AxiosError<any>) => {
  return err.response ? err.response.data.message : err.message;
};

/**
 * returns error code thrown
 * @param {object} err - error object
 */
export const getErrorMessageCode = (err: AxiosError<any>) => {
  return err.response && err.response.data && err.response.data.code;
};

/**
 * returns single data
 * @param {object} res - response object
 */
export const oneData = <T>(res: AxiosResponse<T>) => (Array.isArray(res.data) ? res.data[0] : res.data);

/**
 * returns all data
 * @param {object} res - response object
 */
export const allData = <T>(res: AxiosResponse<T>) => res.data;

/**
 * returns code of err.message
 * @param {object} err - error object
 */
export const getErrorCode = (err: AxiosError<any>) => {
  return (err.response && err.response.status) || 'Uncaught';
};
